import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d09e626e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-cookie_header header"
}
const _hoisted_2 = {
  key: 0,
  class: "header_title"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-d09e626e><g clip-path=\"url(#clip0_6399_13262)\" data-v-d09e626e><path d=\"M16 14.1146L21.6573 8.45732C22.1779 7.9367 23.022 7.93669 23.5426 8.45732C24.0633 8.97794 24.0633 9.82203 23.5426 10.3426L17.8853 16L23.5426 21.6573C24.0633 22.1779 24.0633 23.022 23.5426 23.5426C23.022 24.0633 22.1779 24.0633 21.6573 23.5426L16 17.8853L10.3426 23.5426C9.82203 24.0633 8.97794 24.0633 8.45732 23.5426C7.93669 23.022 7.93669 22.1779 8.45731 21.6573L14.1146 16L8.45732 10.3426C7.9367 9.82203 7.93669 8.97794 8.45732 8.45732C8.97794 7.93669 9.82203 7.93669 10.3426 8.45732L16 14.1146Z\" fill=\"#0E2242\" data-v-d09e626e></path></g><defs data-v-d09e626e><clipPath id=\"clip0_6399_13262\" data-v-d09e626e><rect width=\"32\" height=\"32\" fill=\"white\" data-v-d09e626e></rect></clipPath></defs></svg>", 1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "modal-cookie_body body" }
const _hoisted_6 = { class: "body_wrapper" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "modal-cookie_footer footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ac_button = _resolveComponent("ac-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['modal-cookie', _ctx.isModal ? '-isModal' : ''])
  }, [
    (_ctx.showTitle || _ctx.showCloseBtn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.showTitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('cookie.policySettings')), 1))
            : _createCommentVNode("", true),
          (_ctx.showCloseBtn)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "header_close",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
              }, _hoisted_4))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "body_text",
          innerHTML: _ctx.$t('cookie.descriptionForAll')
        }, null, 8, _hoisted_7),
        _renderSlot(_ctx.$slots, "blocks", {}, undefined, true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.isModal)
        ? (_openBlock(), _createBlock(_component_ac_button, {
            key: 0,
            variant: "outlined",
            class: "footer_button",
            onClick: _ctx.dismiss
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('cookie.dismiss')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_ac_button, {
        class: "footer_button",
        onClick: _ctx.accept,
        disabled: _ctx.disabledAcceptBtn
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('cookie.agreeSelected')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ])
  ], 2))
}